import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    show: false,
    loading: false,
    soundEnabled: true,
    //loginToken:'F1VJmxyRvMsHbauZ%2bejaZURCntxB9RCoOI8WOSBunKzlSeTlsTxE7%2bficujy9O1AI1HjpujpfT0NuEFmBelGMjZmuypNebAUOUgrjEVNhDT0QQuRsjBfhNxc%2bKKSTvThDVo%2fD05MbDaOgpGYpm4zB35U0hfFNZ0Nc%2b9aAS6dFXnmxyDc81UGF3TXrcjtOHH7QWwTNLl2UcLywvFmkbKQCSv8w%2bW48pObgmsoRI8pC5QDdLfPpA%2fB1idYOamNBAlj6ZQ3D%2fMow3XOaSnC3RpDHHh%2ftgh5J%2bfvC%2f%2fBVv1qLrvVtLmVm2SnnKrssvaar5Js12OKUV7pVWGxCzwWWCiOREXMy0b%2feAvsRWW9EOhQbdGCVLRz%2bjNo5Ty%2f6lvSjTnj0C6AVQf1yRTSjJ2tmNSYBPh8f%2fWUVffQnb4EyLb%2fxLtkEeLB6z%2bqLQ%3d%3d',
    loginToken:'',
  },
  getters: {
    // 获取当前开关状态
    isSoundEnabled: (state) => state.soundEnabled
  },
  mutations: {
    handleShow(state, show) {
      state.show = show;
      if (show) {
        state.loading = true
      }
    },
    handleLoading(state, loading) {
      state.loading = loading

    }
  },
  actions: {

  },
  modules: {

  },
});
